import TextMedia from '@/components/_rebrand/TextMedia';
import SerifAndSansSerifHeadline from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import { AlternatingFeaturesProps } from './AlternatingFeatures.types';
import { mapFeaturesToTextMediaFeatures } from './AlternatingFeatures.utils';

const AlternatingFeatures = ({ entry }: AlternatingFeaturesProps) => {
  const features = mapFeaturesToTextMediaFeatures(entry.featuresToDisplay);

  const title = (
    <SerifAndSansSerifHeadline
      primarySansSerif={entry.headerSansSerif}
      secondarySerif={entry.headerSerif}
    />
  );

  return (
    <TextMedia
      title={title}
      features={features}
      alternateFeatures={true}
      isFromCraft={true}
    />
  );
};

export default AlternatingFeatures;
